import { render, staticRenderFns } from "./Action_Jump.vue?vue&type=template&id=f4215ed4&scoped=true"
import script from "./Action_Jump.vue?vue&type=script&lang=js"
export * from "./Action_Jump.vue?vue&type=script&lang=js"
import style0 from "./Action_Jump.vue?vue&type=style&index=0&id=f4215ed4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4215ed4",
  null
  
)

export default component.exports